<template>
  <el-table
    ref="commonTable"
    :empty-text="empty"
    :data="tableData"
    style="width: 100%"
    @selection-change="handleSelectionChange"
    :cell-style="{ whiteSpace: 'nowrap', textOverflow: 'ellipsis' }"
  >
    <el-table-column
      v-if="isShowSection"
      align="center"
      type="selection"
      width="55"
    />
    <el-table-column
      v-for="(item, index) in thead"
      :key="index"
      :prop="tpropty[index]"
      :label="item.label || item"
      :align="item.align || 'center'"
      :min-width="item.width || 0"
    >
      <template slot-scope="scope">
        <span
          v-if="tpropty[index] === 'enabled'"
        ><i
           v-if="isShowEnableIcon"
           :title="scope.row[tpropty[index]] === 1 ? '是' : '否'"
           :class="
             scope.row.enabled === 1 ? 'el-icon-success' : 'el-icon-error'
           "
         />
          <template v-else>{{
            scope.row[tpropty[index]] === 1 ? "是" : "否"
          }}</template>
        </span>
        <span v-else-if="tpropty[index] === 'lastModified'">{{
          scope.row.lastModified | timeFilter
        }}</span>
        <template v-else>
          <template v-if="item.isCanEdit">
            <el-select
              v-if="item.type === 'select'"
              v-model="scope.row[tpropty[index]]"
              :popper-append-to-body="true"
              popper-class="dialog-select"
            >
              <el-option
                v-for="(itemOption, indexOption) of item.options"
                :key="indexOption"
                :label="itemOption.label || itemOption"
                :value="
                  itemOption.value !== undefined ? itemOption.value : itemOption
                "
              />
            </el-select>
            <el-input
              v-else
              v-model="scope.row[tpropty[index]]"
            />
          </template>
          <span
            v-else
            :title="scope.row[tpropty[index]]"
          >{{
            scope.row[tpropty[index]]
          }}</span>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'DataManageTable',
  props: {
    isShowSection: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: () => []
    },
    thead: {
      type: Array,
      default: () => []
    },
    tpropty: {
      type: Array,
      default: () => []
    },
    empty: {
      type: String,
      default: '暂无数据'
    },
    isShowEnableIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-table {
  &__header {
    th {
      height: 40px;
      background: #3b91dd;
      border-left: 1px solid #a7ccec;
      font-size: 13px;
      color: #fff;
      font-weight: 500;
    }
    &-wrapper {
      border-radius: 5px 5px 0px 0px;
    }
  }
  &__body {
    td {
      height: 60px;
      font-size: 13px;
      color: #666;
      border-bottom: 1px solid #e8e8e8;
      .cell {
        @extend .ellipsis;
      }
      i.el-icon-success {
        color: #52a544;
      }
      i.el-icon-error {
        color: #999999;
      }
    }
  }
}
</style>
